// ExtendBillingForm.tsx
import React from 'react'
import classes from './ExtendBillingForm.module.sass'
import { ClusterInterface } from '../../../../../common/types/interfaces'
import { useExtendBillingForm } from './useExtendBillingForm'
import { Button } from '../../../../../common/components/button/Button'


type Props = {
  cluster: ClusterInterface | undefined
  setModalActive: (state: boolean) => void
  getList: () => void
}

export const ExtendBillingForm = ({ cluster, setModalActive, getList }: Props) => {
  const { paidUntil, loading, minDate, handleDateChange, submit } = useExtendBillingForm({
    cluster,
    setModalActive,
    getList,
  })

  return (
    <div className={classes.Container}>
      <div className={classes.Title}>Продлить подписку</div>
      <div className={classes.Description}>{cluster?.name}</div>
      <input
        type="date"
        className={classes.DateInput}
        value={paidUntil}
        min={minDate}
        onChange={(e) => handleDateChange(e.target.value)}
      />
      <div className={classes.ButtonGroup}>
        <Button
          text={loading ? 'Сохранение...' : 'Продлить'}
          onClick={submit}
          disabled={loading || !paidUntil}
        />
      </div>
    </div>
  )
}
